import { render, staticRenderFns } from "./cabinet-bar.vue?vue&type=template&id=4ac9c0a1&scoped=true"
import script from "./cabinet-bar.vue?vue&type=script&lang=ts"
export * from "./cabinet-bar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac9c0a1",
  null
  
)

export default component.exports